import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddSalaryPay() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/SalaryPayLookup?${searchParams.toString()}`;
  return (
    <AddLookup
      title="Add Salary Pay"
      alert="Salary Pay Added Successfully"
      addDataAPIEndpoint="/SalaryPayFrequency/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Salary Pay Type",
              name: "SPFL_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "SPFL_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value: "1" },
                { label: "Inactive", value: "2" },
              ],
            },
          ],
        },
      ]}
      validationRules={{
        SPFL_Name: {
          required: true,
        },
        SPFL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddSalaryPay;
